function Innerbanner(props){

console.log(props);
    return(

<div className="container-fluid innerbanner align-bottom border">

   <div className="container">
    <h1 className="align-bottom text-white"> {props.title}<br/><span className="h4">By Top Famous Astrologr in Gurugram</span>
        </h1>
  
    </div>


</div>



    );







    
}
export {Innerbanner} ;